import { Trash2 } from "lucide-react";
import { useState } from "react";
import { ConfirmModal } from "@/components/ConfirmModal";
import { deleteWeek } from "@/lib/repos/weeks";

interface Props {
  weekId: string;
}

export function DeleteWeekButton({ weekId }: Props) {
  const [open, setOpen] = useState(false);

  const handleConfirm = async () => {
    setOpen(false);
    await deleteWeek(weekId);
  };

  return (
    <div className="page-toolbar page-toolbar--danger-zone">
      <button
        type="button"
        className="btn danger icon-btn"
        onClick={() => setOpen(true)}
        data-testid="delete-week-button"
      >
        <Trash2 size={16} />
        Slett uken
      </button>
      <ConfirmModal
        open={open}
        title="Slett uken?"
        body="Uken og alt innhold blir slettet."
        confirmLabel="Slett uken"
        confirmIcon={<Trash2 size={16} />}
        onConfirm={handleConfirm}
        onCancel={() => setOpen(false)}
        data-testid="delete-week-confirm-modal"
      />
    </div>
  );
}
